<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">

                <h2>Cardiologie – sănătatea inimii tale, pe mâini sigure</h2>

                <p>
                  Cardiologia se ocupă cu prevenția, diagnosticarea și monitorizarea
                  afecțiunilor cardiovasculare. Consultația cardiologică urmărește
                  evaluarea stării de sănătate a inimii și identificarea factorilor
                  de risc cardiovascular, pentru stabilirea unei conduite medicale
                  adaptate fiecărui pacient.
                </p>

                <p>
                  O evaluare cardiologică poate fi importantă atât atunci când apar
                  simptome precum palpitații, dureri în piept sau senzație de lipsă
                  de aer, cât și pentru monitorizarea periodică a stării de sănătate.
                </p>


                <!-- Echipa medicală -->
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                    data-aos-delay="500">

                    <a href="/echipa_medicala/alexandra_ioana_nastasa#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img">
                          <img
                            src="../../../assets/images/doctors/dr-alexandra-ioana-nastasa.jpeg"
                            alt="Dr. Alexandra Ioana Năstasă"
                          >
                        </div>

                        <div class="team-info">
                          <span>Dr. Alexandra Ioana Năstasă</span>
                        </div>
                      </div>
                    </a>

                  </div>
                </div>


                <h3>Servicii</h3>

                <p>
                  În cadrul cabinetului de cardiologie sunt disponibile servicii
                  pentru evaluarea și monitorizarea sănătății cardiovasculare,
                  adaptate nevoilor fiecărui pacient.
                </p>


                <div class="card mb-10" v-for="service in services" :key="service.name">
                  <div class="row" style="padding: 10px 20px;">

                    <div class="card-service col-xl-10 col-lg-10 col-md-10">
                      <i
                        class="ri-check-double-line"
                        style="vertical-align: bottom;"
                      ></i>
                      {{ service.name }}
                    </div>

                    <div class="service-price col-xl-2 col-lg-2 col-md-2 text-align-right">
                      <!-- {{ service.price }} Lei -->
                    </div>

                  </div>
                </div>


                <div class="other-option md-none mb-40">
                  <a href="/#appointment" class="btn style2">
                    Solicită o programare
                  </a>
                </div>

 


                <h3>Întrebări frecvente</h3>

                <p>
                  Mai jos găsești răspunsuri la câteva dintre cele mai frecvente
                  întrebări legate de consultațiile cardiologice.
                </p>


                <div class="accordion" id="accordionExample_one">

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>

                        Când este recomandată o consultație cardiologică?
                      </button>
                    </h2>

                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample_one"
                    >
                      <div class="accordion-body">
                        <p>
                          Consultația cardiologică este recomandată atunci când apar
                          simptome precum palpitații, dureri sau disconfort în piept,
                          amețeli, oboseală neobișnuită sau senzație de lipsă de aer.
                          De asemenea, evaluarea poate fi utilă pentru monitorizarea
                          periodică a sănătății cardiovasculare.
                        </p>
                      </div>
                    </div>
                  </div>


                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>

                        Este necesară trimitere pentru consultație?
                      </button>
                    </h2>

                    <div
                      id="collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample_one"
                    >
                      <div class="accordion-body">
                        <p>
                          Pentru consultațiile în cadrul clinicii private,
                          programarea se poate face direct. În cazul serviciilor
                          decontate prin sistemul public, condițiile pot fi
                          diferite în funcție de serviciul medical.
                        </p>
                      </div>
                    </div>
                  </div>


                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>

                        Ce investigații pot fi recomandate la consultație?
                      </button>
                    </h2>

                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample_one"
                    >
                      <div class="accordion-body">
                        <p>
                          În funcție de simptome și de istoricul medical, medicul
                          poate recomanda investigații precum electrocardiograma,
                          ecocardiografia sau alte evaluări necesare pentru
                          stabilirea diagnosticului și monitorizarea stării
                          cardiovasculare.
                        </p>
                      </div>
                    </div>
                  </div>


                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>

                        Pot face un control cardiologic preventiv?
                      </button>
                    </h2>

                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample_one"
                    >
                      <div class="accordion-body">
                        <p>
                          Da. Un control cardiologic preventiv poate contribui la
                          identificarea din timp a unor factori de risc și la
                          monitorizarea sănătății cardiovasculare, mai ales în
                          prezența unor factori de risc precum hipertensiunea
                          arterială, colesterolul crescut, diabetul sau istoricul
                          familial cardiovascular.
                        </p>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "CardiologiePage",

  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    MainFooter,
  },

  data() {
    return {
      isSticky: false,

      services: [
        {
          name: "Consultație cardiologică",
          price: 300
        },
        {
          name: "Electrocardiogramă (EKG)",
          price: 100
        },
        {
          name: "Ecocardiografie",
          price: 250
        },
        {
          name: "Consultație cardiologică + EKG",
          price: 350
        },
        {
          name: "Evaluare și monitorizare cardiovasculară",
          price: 300
        }
      ]
    };
  },

  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;

      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script> 
